import PeriodSelectionDTO = App.Data.Explorer.PeriodSelectionDTO;
import dayjs from "dayjs";
import { QUnitType } from "dayjs";

export default function (periodSelection: PeriodSelectionDTO) {
	// PHP does not use milliseconds, but JavaScript does.
	// We need to set the milliseconds to 0 and 999 respectively to keep it consistent.
	const start = dayjs(periodSelection.from_parsed).set("ms", 0);
	const end = dayjs(periodSelection.to_parsed).set("ms", 999);

	const units: {
		unit: QUnitType | "isoWeek";
		name: string;
		format: string;
	}[] = [
		{ unit: "year", name: "Year", format: "" }, // Year is always appended, which means we don't need a format for it.
		{ unit: "quarter", name: "", format: "[Q]Q" },
		{ unit: "month", name: "", format: "MMMM" },
		{ unit: "isoWeek", name: "", format: "[Week] W" },
		{ unit: "day", name: "", format: "dddd D MMMM" },
	];

	const unitToApply = units.find((unit) => {
		const startIsStartOfUnit = start.isSame(
			start.clone().startOf(unit.unit as QUnitType)
		);
		const endIsEndOfUnit = end.isSame(
			end.clone().endOf(unit.unit as QUnitType)
		);

		return startIsStartOfUnit && endIsEndOfUnit;
	});

	if (unitToApply) {
		if (start.isSame(end, unitToApply.unit as QUnitType)) {
			return `${unitToApply.name} <b>${start.format(
				(unitToApply.format + " YYYY").trim()
			)}</b>`;
		}

		// Include the year in the start year when the start and end year differ.
		let startYearFormat = "";
		if (!start.isSame(end, "year")) {
			startYearFormat = " YYYY";
		}

		return `${unitToApply.name} <b>${start.format(
			unitToApply.format + startYearFormat
		)}</b> through <b>${end.format((unitToApply.format + " YYYY").trim())}</b>`;
	}

	// Custom case for today so far
	if (start.isSame(end, "day")) {
		return `<b>${start.format("dddd D MMMM YYYY")}</b> until <b>${end.format(
			"HH:mm"
		)}</b>`;
	}

	// Fallback scenario for when the ranges do not start at the beginning of a unit and end at the end of a unit.
	// The smallest unit is day which means this case happens with dates such as 2025-01-01 04:00:00 tot 2025-01-02 20:00:00.
	let startFormat = "dddd D MMMM";
	if (!start.isSame(start.clone().startOf("day"))) {
		startFormat += " HH:mm";
	}
	if (!start.isSame(end, "year")) {
		startFormat += " YYYY";
	}

	let endFormat = "dddd D MMMM YYYY";
	if (!end.isSame(end.clone().endOf("day"))) {
		endFormat += " HH:mm";
	}

	return `<b>${start.format(startFormat)}</b> through <b>${end
		.format(endFormat)
		.trim()}</b>`;
}
